module.exports = __webpack_public_path__ + "static/img02-bededb19797ed1fac8b75cc74e2ef726.jpg";